import React, { useState, useRef } from "react";
import { UploadZone, DownloadButton, ResetButton, loadImage } from "./_shared";

export default function CropImage() {
  const [file, setFile] = useState(null);
  const [src, setSrc] = useState(null);
  const [outUrl, setOutUrl] = useState(null);
  const [rect, setRect] = useState({ x: 20, y: 20, w: 200, h: 200 });
  const [drag, setDrag] = useState(null);
  const imgRef = useRef(null);
  const wrapRef = useRef(null);

  const handleFile = async (f) => {
    setFile(f); setSrc(URL.createObjectURL(f));
    setRect({ x: 20, y: 20, w: 200, h: 200 });
  };

  const onDown = (e, mode) => {
    e.preventDefault();
    setDrag({ mode, startX: e.clientX, startY: e.clientY, rect: { ...rect } });
  };
  const onMove = (e) => {
    if (!drag) return;
    const dx = e.clientX - drag.startX;
    const dy = e.clientY - drag.startY;
    if (drag.mode === "move") {
      setRect({ ...drag.rect, x: Math.max(0, drag.rect.x + dx), y: Math.max(0, drag.rect.y + dy) });
    } else {
      setRect({ ...drag.rect, w: Math.max(20, drag.rect.w + dx), h: Math.max(20, drag.rect.h + dy) });
    }
  };
  const onUp = () => setDrag(null);

  const process = async () => {
    const { img } = await loadImage(file);
    const imgEl = imgRef.current;
    const scale = img.naturalWidth / imgEl.clientWidth;
    const canvas = document.createElement("canvas");
    canvas.width = rect.w * scale; canvas.height = rect.h * scale;
    canvas.getContext("2d").drawImage(
      img,
      rect.x * scale, rect.y * scale, rect.w * scale, rect.h * scale,
      0, 0, canvas.width, canvas.height,
    );
    canvas.toBlob((blob) => {
      if (outUrl) URL.revokeObjectURL(outUrl);
      setOutUrl(URL.createObjectURL(blob));
    }, file.type || "image/png", 0.95);
  };

  const reset = () => { setFile(null); setSrc(null); setOutUrl(null); };

  if (!file) return <UploadZone onFile={handleFile} />;
  return (
    <div className="space-y-6" onMouseMove={onMove} onMouseUp={onUp} onMouseLeave={onUp}>
      <div ref={wrapRef} className="relative inline-block rounded-2xl overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] border border-slate-200 dark:border-white/10 select-none w-full">
        <img ref={imgRef} src={src} alt="src" className="w-full max-h-[500px] object-contain" draggable={false} />
        <div
          onMouseDown={(e) => onDown(e, "move")}
          style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }}
          className="absolute border-2 border-blue-500 bg-blue-500/10 cursor-move"
        >
          <div
            onMouseDown={(e) => { e.stopPropagation(); onDown(e, "resize"); }}
            className="absolute -right-1.5 -bottom-1.5 w-3 h-3 bg-blue-600 rounded-sm cursor-nwse-resize"
          />
        </div>
      </div>
      {outUrl && (
        <div>
          <p className="text-sm font-medium text-slate-700 dark:text-slate-200 mb-2">Cropped result</p>
          <img src={outUrl} alt="cropped" className="max-h-64 rounded-xl border border-slate-200 dark:border-white/10" />
        </div>
      )}
      <div className="flex items-center gap-3">
        <button onClick={process} data-testid="tool-process-button" className="px-5 py-2.5 rounded-full bg-slate-900 dark:bg-white text-white dark:text-slate-900 text-sm font-medium hover:opacity-90 transition-opacity">Apply Crop</button>
        <DownloadButton href={outUrl} filename={`crop-${file.name}`}>Download</DownloadButton>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
